/*
    Should be rendered within DrawerContainer
    Closes the drawer container

    allows for title to past through when rendering the snippet
    the title can be any form of html
    see side cart for example

*/


import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { cart } from '@/theme/Cart';

@Component
export class DrawerHeader extends ThemeComponent {
    @Ref closeButton!: HTMLButtonElement;
    @Ref({required: false}) count!: HTMLElement;

    private close: string = '';
    private _onCloseChange = new SimpleEvent<string>();

    public get onCloseChange() {
        return this._onCloseChange.asEvent();
    }

    public changeClose(close: string) {
        this.close = close;

        // Use the private backing field to dispatch
        this._onCloseChange.dispatch(close);
    }

    /** Initialise component */
    init() {
        this.updateCount();
        this.$listen(this.closeButton, 'click', () => {
            this._onCloseChange.dispatch(this.close);
        });
    }

    /**
     * Update cart count.
     * For the side cart drawer.
     * @returns
     */
    updateCount() {
        if (!this.count) { return; }
        document.addEventListener('cartChanged', (e: Event) => {
            const count = cart.getCartItemCount();
            this.count.innerHTML = String(count);
        });
    }
}
